const arrColor = [
   {c_name: "Шоколад", c_code: "#3d1505"},
   {c_name: "Мокко", c_code: "#a47764"},
   {c_name: "Бежевый", c_code: "#bc9d7c"},
   {c_name: "Тиффани", c_code: "#839e9c"},
   {c_name: "Темно_синий", c_code: "#182f4a"},
   {c_name: "Винный", c_code: "#700921"},
   {c_name: "Лаванда", c_code: "#7c6c91"},
   {c_name: "Персик", c_code: "#ca7e46"},
   {c_name: "Фисташка", c_code: "#928c66"},
   {c_name: "Золото", c_code: "#9e6d28"},
   {c_name: "Серебро", c_code: "#aeafab"},
   {c_name: "Хакки", c_code: "#273311"},
   {c_name: "Изумруд", c_code: "#0b614b"},
   {c_name: "Розовый", c_code: "#b5758b"},
   {c_name: "Черный", c_code: "#222222"},
   {c_name: "Фиолетовый", c_code: "#493342"},
   {c_name: "Голубой", c_code: "#738ba2"},
   {c_name: "Белый", c_code: "#ffffff"},
   {c_name: "Металлик", c_code: "#6d6a65"},
]

export default arrColor;